var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "main-internal-section width-full float-l" }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            _vm.cantAccessPage === true
              ? [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "chat-btm-section-main add-user-main-section width-full float-l"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "chat-web-section chat-user-list-main float-l width-full"
                          },
                          [
                            _c(
                              "h2",
                              {
                                staticClass:
                                  "chat-page-title float-l width-full color-333333 heading-text-24 line-height-28 font-bold ucase pb_5"
                              },
                              [_vm._v(" Customer List ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "user-listing-section-web customer-listing-section-web float-l width-full"
                              },
                              [
                                _c("vue-good-table", {
                                  ref: "listUserList",
                                  attrs: {
                                    mode: "remote",
                                    title: "Customer",
                                    totalRows: _vm.totalRecords,
                                    columns: _vm.columns,
                                    rows: _vm.rows,
                                    "pagination-options": {
                                      enabled: true,
                                      position: "bottom",
                                      perPage: 10,
                                      dropdownAllowAll: false
                                    },
                                    "search-options": {
                                      enabled: false
                                    }
                                  },
                                  on: {
                                    "on-page-change": _vm.onPageChange,
                                    "on-selected-rows-change":
                                      _vm.selectionChanged,
                                    "on-column-filter": _vm.onColumnFilter,
                                    "on-per-page-change": _vm.onPerPageChange,
                                    "on-sort-change": _vm.onSortChange
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "user-list-mobile float-l width-full"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "add-user-form col-12 float-l mt_10"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group float-l width-full pt_15 pl_15 pr_15 pb_0"
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
                                      },
                                      [_vm._v(" Section ")]
                                    ),
                                    _vm._v(" "),
                                    _c("v-select", {
                                      attrs: {
                                        name: "timezoneId",
                                        placeholder: "Select Section.",
                                        label: "text",
                                        options: _vm.sectionArr
                                      },
                                      model: {
                                        value: _vm.sectionId,
                                        callback: function($$v) {
                                          _vm.sectionId = $$v
                                        },
                                        expression: "sectionId"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.customerArray && _vm.customerArray.length > 0
                              ? _vm._l(_vm.customerArray, function(customer) {
                                  return _c(
                                    "div",
                                    {
                                      staticClass:
                                        "customer-list-main col-12 float-l"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "internal-customer-list float-l width-full"
                                        },
                                        [
                                          _c(
                                            "h4",
                                            {
                                              staticClass:
                                                "heading-text-16 line-height-20 color-333333 font-benton-medium float-l width-full mb_6"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(customer.name) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "heading-text-14 line-height-18 color-888888 font-text-regular-benton float-l width-full mb_0"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(customer.email) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                title: "View User",
                                                to: {
                                                  name: "CustomerDetails",
                                                  params: { id: customer.id }
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-angle-right"
                                              })
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                })
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    )
                  ])
                ]
              : [_vm.isRequestComplete ? [_vm._m(0)] : _vm._e()]
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "error-template" }, [
        _c("h1", [_vm._v("\n                                Oops!")]),
        _vm._v(" "),
        _c("h2", [_vm._v("\n                                403 ")]),
        _vm._v(" "),
        _c("div", { staticClass: "error-details" }, [
          _vm._v(
            "\n                                Sorry!, You don't have permission to access this page.\n                            "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a72f1cd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a72f1cd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customer/CustomerList.vue
// module id = null
// module chunks = 